import exportedVars from './exported-variables.scss';

const SCREEN_BREAKPOINT_MEDIUM = parseInt(exportedVars?.screenBreakpointMedium || '768');
const SCREEN_BREAKPOINT_LARGE = parseInt(exportedVars?.screenBreakpointLarge || '1296');

export { SCREEN_BREAKPOINT_MEDIUM, SCREEN_BREAKPOINT_LARGE };
